import { Box } from '@mui/material';

import AIOBackgroundImage from '../../../images/kixie-aio-outcome-background.png';

export const AIOOutcomeBackground = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: { xs: '50vh', md: '60vh' },
        backgroundImage: `url(${AIOBackgroundImage})`,
        backgroundColor: 'black',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderBottomLeftRadius: { xs: 25, md: 50 },
        borderBottomRightRadius: { xs: 25, md: 50 },
        zIndex: 0,
      }}
    />
  );
};
